import React from 'react'
import { type SVGProps } from 'react'
const ShrinkIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={25}
    height={25}
    fill="none"
    {...props}
  >
    <path
      fill='#333'
      d='M14.016 12.094c-1.079 0-1.875-.797-1.875-1.875V3.28c0-.937.703-1.687 1.64-1.687.422 0 .844.187 1.172.515l1.313 1.313 2.53-2.578c.845-.844 2.298-.844 3.142 0L23.39 2.25c.843.89.843 2.344 0 3.188l-2.578 2.53 1.312 1.313c.328.328.516.75.516 1.172 0 .938-.75 1.64-1.688 1.64h-6.937Zm4.453-3.328c-.469-.422-.469-1.125 0-1.594l3.328-3.328-1.453-1.406-3.328 3.328a1.026 1.026 0 0 1-1.547 0L14.39 4.687v5.157h5.156l-1.078-1.078ZM3.28 12.094h6.985a1.88 1.88 0 0 1 1.875 1.875v6.984c0 .938-.75 1.64-1.688 1.64-.422 0-.844-.14-1.172-.468l-1.265-1.313-2.532 2.532c-.89.89-2.343.89-3.187 0L.89 21.937a2.18 2.18 0 0 1 0-3.14l2.53-2.578-1.312-1.266a1.627 1.627 0 0 1-.468-1.172c0-.937.703-1.687 1.64-1.687Zm2.531 3.328-.046.047a1.026 1.026 0 0 1 0 1.547l-3.329 3.328 1.454 1.453 3.328-3.328c.422-.469 1.125-.469 1.593 0l1.079 1.078v-5.203H4.734l1.079 1.078Z'
    />
  </svg>
)
export default ShrinkIcon
